// eDNA variables and raw dimension calculations

export const attributeNames = [
    'intelligent',
    'real',
    'fun',
    'touching',
    'relatable',
    'sad',
    'romantic',
    'informative',
    'mean',
    'fake',
    'glamorous',
    'original',
    'predictable',
    'fresh',
    'mindless',
    'unrelatable',
    'funny',
    'imaginative',
    'wholesome',
    'inspiring',
    'shallow',
    'edgy',
    'fastpaced',
    'disturbing',
    'dramatic',
    'outrageous',
    'exciting',
    'calming',
    'slow',
    'unoriginal',
    'uplifting',
    'sexy',
    'deep',
    'suspenseful',
    'thrilling',
    'scary'
];

export const dimensionNames = [
    'originality',
    'relatability',
    'adrenaline',
    'gravity',
    'passion',
    'smarts',
    'levity',
    'heart',
];

export const dimensionsNamesDisplay =[];
dimensionNames.map((dimension)=>(
    dimensionsNamesDisplay.push(dimension[0].toUpperCase()+dimension.slice(1))
));

export const dimPctNames = [
    'originality_pct',
    'relatability_pct',
    'adrenaline_pct',
    'gravity_pct',
    'passion_pct',
    'smarts_pct',
    'levity_pct',
    'heart_pct',
];

export const dimMinMax = {
    'originality': {'min': 0.0443, 'max': 1.6826},
    'relatability': {'min': -1.6140, 'max': 0.1150},
    'adrenaline': {'min': -0.1840, 'max': 1.7607},
    'gravity': {'min': -0.7054, 'max': 2.3754},
    'passion': {'min': -0.2818, 'max': 0.8662},
    'smarts': {'min': -0.8932, 'max': 1.2128},
    'levity': {'min': -0.3813, 'max': 1.3917},
    'heart': {'min': -0.4608, 'max': 2.4616},
};


export function getDimValueRaw(attValue) {
    return {
        'gravity': attValue['intelligent']*(0.0566)
                + attValue['real']*(0.0633)
                + attValue['fun']*(-0.5719)
                + attValue['touching']*(0.2362)
                + attValue['relatable']*(-0.1885)
                + attValue['sad']*(0.6509)
                + attValue['romantic']*(0.0966)
                + attValue['informative']*(-0.0098)
                + attValue['mean']*(0.2346)
                + attValue['fake']*(0.00267)
                + attValue['glamorous']*(-0.0503)
                + attValue['original']*(0.0778)
                + attValue['predictable']*(-0.0349)
                + attValue['fresh']*(-0.1928)
                + attValue['mindless']*(-0.2014)
                + attValue['unrelatable']*(0.1428)
                + attValue['funny']*(-0.3618)
                + attValue['imaginative']*(0.0485)
                + attValue['wholesome']*(-0.2698)
                + attValue['inspiring']*(-0.1181)
                + attValue['shallow']*(0.0388)
                + attValue['edgy']*(0.5272)
                + attValue['fastpaced']*(-0.0742)
                + attValue['disturbing']*(0.8386)
                + attValue['dramatic']*(0.6054)
                + attValue['outrageous']*(0.1695)
                + attValue['exciting']*(0.0027)
                + attValue['calming']*(-0.0690)
                + attValue['slow']*(0.1780)
                + attValue['unoriginal']*(0.0749)
                + attValue['uplifting']*(-0.1607)
                + attValue['sexy']*(0.0744)
                + attValue['deep']*(0.6547)
                + attValue['suspenseful']*(0.7306)
                + attValue['thrilling']*(0.5945)
                + attValue['scary']*(0.7184),
        'relatability': attValue['intelligent']*(-0.0018)
                    + attValue['real']*(0.1228)
                    + attValue['fun']*(0.1)
                    + attValue['touching']*(-0.1674)
                    + attValue['relatable']*(-0.2025)
                    + attValue['sad']*(-0.1801)
                    + attValue['romantic']*(-0.5474)
                    + attValue['informative']*(0.1130)
                    + attValue['mean']*(-0.6516)
                    + attValue['fake']*(-0.6077)
                    + attValue['glamorous']*(-0.6394)
                    + attValue['original']*(0.2551)
                    + attValue['predictable']*(-0.5484)
                    + attValue['fresh']*(-0.2575)
                    + attValue['mindless']*(-0.5371)
                    + attValue['unrelatable']*(-0.7148)
                    + attValue['funny']*(0.0382)
                    + attValue['imaginative']*(-0.0688)
                    + attValue['wholesome']*(0.0529)
                    + attValue['inspiring']*(-0.1188)
                    + attValue['shallow']*(-0.7374)
                    + attValue['edgy']*(-0.1214)
                    + attValue['fastpaced']*(-0.0214)
                    + attValue['disturbing']*(-0.0536)
                    + attValue['dramatic']*(0.0258)
                    + attValue['outrageous']*(-0.3390)
                    + attValue['exciting']*(0.0428)
                    + attValue['calming']*(-0.3810)
                    + attValue['slow']*(-0.5716)
                    + attValue['unoriginal']*(-0.6579)
                    + attValue['uplifting']*(-0.0822)
                    + attValue['sexy']*(-0.6501)
                    + attValue['deep']*(-0.2190)
                    + attValue['suspenseful']*(0.1033)
                    + attValue['thrilling']*0.1033
                    + attValue['scary']*(-0.1378),
        'heart': attValue['intelligent']*0.0961
                + attValue['real']*0.2139
                + attValue['fun']*0.2656
                + attValue['touching']*0.7460
                + attValue['relatable']*0.4773
                + attValue['sad']*0.0871
                + attValue['romantic']*0.2821
                + attValue['informative']*0.0039
                + attValue['mean']*0.0317
                + attValue['fake']*(-0.0637)
                + attValue['glamorous']*0.1796
                + attValue['original']*0.2223
                + attValue['predictable']*0.1249
                + attValue['fresh']*0.3665
                + attValue['mindless']*(-0.0699)
                + attValue['unrelatable']*0.0644
                + attValue['funny']*0.1306
                + attValue['imaginative']*0.1361
                + attValue['wholesome']*0.7264
                + attValue['inspiring']*0.6588
                + attValue['shallow']*(-0.0060)
                + attValue['edgy']*(-0.2574)
                + attValue['fastpaced']*(-0.1193)
                + attValue['disturbing']*(-0.2088)
                + attValue['dramatic']*(-0.1083)
                + attValue['outrageous']*(-0.1978)
                + attValue['exciting']*0.0238
                + attValue['calming']*0.5460
                + attValue['slow']*0.1551
                + attValue['unoriginal']*0.1290
                + attValue['uplifting']*0.7698
                + attValue['sexy']*0.03090
                + attValue['deep']*0.1571
                + attValue['suspenseful']*(-0.2507)
                + attValue['thrilling']*(-0.2217)
                + attValue['scary']*(-0.1529),
        'originality': attValue['intelligent']*0.6812
                        + attValue['real']*(-0.1208)
                        + attValue['fun']*(0.07394)
                        + attValue['touching']*0.0472
                        + attValue['relatable']*0.2095
                        + attValue['sad']*(-0.0883)
                        + attValue['romantic']*0.0943
                        + attValue['informative']*0.2267
                        + attValue['mean']*0.0521
                        + attValue['fake']*(-0.1179)
                        + attValue['glamorous']*0.0505
                        + attValue['original']*0.6236
                        + attValue['predictable']*(-0.0836)
                        + attValue['fresh']*0.4735
                        + attValue['mindless']*(-0.1533)
                        + attValue['unrelatable']*(-0.02561)
                        + attValue['funny']*0.1
                        + attValue['imaginative']*0.5823
                        + attValue['wholesome']*0.0653
                        + attValue['inspiring']*0.1984
                        + attValue['shallow']*(-0.0117)
                        + attValue['edgy']*0.2842
                        + attValue['fastpaced']*0.0016
                        + attValue['disturbing']*(-0.1030)
                        + attValue['dramatic']*0.0653
                        + attValue['outrageous']*0.0055
                        + attValue['exciting']*0.1512
                        + attValue['calming']*0.1307
                        + attValue['slow']*0.1093
                        + attValue['unoriginal']*0.05054
                        + attValue['uplifting']*0.0783
                        + attValue['sexy']*0.1239
                        + attValue['deep']*0.2804
                        + attValue['suspenseful']*0.0705
                        + attValue['thrilling']*0.0869
                        + attValue['scary']*(-0.05171),
        'adrenaline': attValue['intelligent']*(-0.0631)
                    + attValue['real']*(-0.0223)
                    + attValue['fun']*0.1460
                    + attValue['touching']*(-0.1214)
                    + attValue['relatable']*(-0.1899)
                    + attValue['sad']*(-0.1826)
                    + attValue['romantic']*(-0.0365)
                    + attValue['informative']*(-0.2125)
                    + attValue['mean']*(-0.0086)
                    + attValue['fake']*(-0.0314)
                    + attValue['glamorous']*0.0698
                    + attValue['original']*0.0731
                    + attValue['predictable']*0.0080
                    + attValue['fresh']*0.1247
                    + attValue['mindless']*(-0.1065)
                    + attValue['unrelatable']*(-0.0497)
                    + attValue['funny']*(-0.2190)
                    + attValue['imaginative']*0.2129
                    + attValue['wholesome']*(-0.0764)
                    + attValue['inspiring']*0.1038
                    + attValue['shallow']*(-0.0679)
                    + attValue['edgy']*0.1963
                    + attValue['fastpaced']*0.6994
                    + attValue['disturbing']*(-0.1429)
                    + attValue['dramatic']*0.1910
                    + attValue['outrageous']*0.0224
                    + attValue['exciting']*0.8586
                    + attValue['calming']*(-0.0904)
                    + attValue['slow']*0.0094
                    + attValue['unoriginal']*0.0092
                    + attValue['uplifting']*(-0.0333)
                    + attValue['sexy']*0.0948
                    + attValue['deep']*(-0.0591)
                    + attValue['suspenseful']*0.3597
                    + attValue['thrilling']*0.6126
                    + attValue['scary']*0.0265,
        'smarts': attValue['intelligent']*0.3231
                + attValue['real']*0.8131
                + attValue['fun']*(-0.3857)
                + attValue['touching']*(-0.0037)
                + attValue['relatable']*0.1099
                + attValue['sad']*0.1575
                + attValue['romantic']*(-0.1994)
                + attValue['informative']*0.7706
                + attValue['mean']*0.0917
                + attValue['fake']*(-0.0564)
                + attValue['glamorous']*0.0010
                + attValue['original']*(-0.0261)
                + attValue['predictable']*(-0.0684)
                + attValue['fresh']*(-0.0105)
                + attValue['mindless']*(-0.1447)
                + attValue['unrelatable']*0.0222
                + attValue['funny']*(-0.4329)
                + attValue['imaginative']*(-0.3587)
                + attValue['wholesome']*(-0.0522)
                + attValue['inspiring']*0.2804
                + attValue['shallow']*0.0090
                + attValue['edgy']*(-0.1164)
                + attValue['fastpaced']*0.0014
                + attValue['disturbing']*0.1287
                + attValue['dramatic']*(-0.1943)
                + attValue['outrageous']*(-0.0702)
                + attValue['exciting']*(-0.1168)
                + attValue['calming']*0.0228
                + attValue['slow']*0.0177
                + attValue['unoriginal']*(-0.0027)
                + attValue['uplifting']*(-0.0039)
                + attValue['sexy']*(-0.1270)
                + attValue['deep']*0.1176
                + attValue['suspenseful']*(-0.1985)
                + attValue['thrilling']*(-0.1751)
                + attValue['scary']*(-0.0287),
        'passion': attValue['intelligent']*0.0159
                + attValue['real']*(-0.0078)
                + attValue['fun']*(-0.2081)
                + attValue['touching']*0.2639
                + attValue['relatable']*(-0.0289)
                + attValue['sad']*0.1284
                + attValue['romantic']*0.3362
                + attValue['informative']*(-0.1404)
                + attValue['mean']*(-0.0348)
                + attValue['fake']*0.0976
                + attValue['glamorous']*0.2540
                + attValue['original']*0.0648
                + attValue['predictable']*(-0.0266)
                + attValue['fresh']*(-0.0056)
                + attValue['mindless']*(-0.0269)
                + attValue['unrelatable']*(-0.0481)
                + attValue['funny']*(-0.0456)
                + attValue['imaginative']*(-0.0410)
                + attValue['wholesome']*(-0.2201)
                + attValue['inspiring']*0.0436
                + attValue['shallow']*0.0082
                + attValue['edgy']*0.1294
                + attValue['fastpaced']*(-0.0276)
                + attValue['disturbing']*(-0.1209)
                + attValue['dramatic']*0.4766
                + attValue['outrageous']*0.0326
                + attValue['exciting']*0.0858
                + attValue['calming']*(-0.2121)
                + attValue['slow']*(-0.1888)
                + attValue['unoriginal']*(-0.1653)
                + attValue['uplifting']*0.0681
                + attValue['sexy']*0.3696
                + attValue['deep']*0.1157
                + attValue['suspenseful']*0.1055
                + attValue['thrilling']*0.0000
                + attValue['scary']*(-0.2182),
        'levity': attValue['intelligent']*(-0.2297)
                + attValue['real']*(-0.0079)
                + attValue['fun']*0.4568
                + attValue['touching']*0.0025
                + attValue['relatable']*0.1147
                + attValue['sad']*0.1037
                + attValue['romantic']*(-0.0769)
                + attValue['informative']*(-0.2547)
                + attValue['mean']*0.1496
                + attValue['fake']*0.0800
                + attValue['glamorous']*0.0468
                + attValue['original']*0.1222
                + attValue['predictable']*(-0.0466)
                + attValue['fresh']*0.1874
                + attValue['mindless']*0.3552
                + attValue['unrelatable']*0.0208
                + attValue['funny']*0.6316
                + attValue['imaginative']*0.0407
                + attValue['wholesome']*(-0.0864)
                + attValue['inspiring']*(-0.1468)
                + attValue['shallow']*0.1563
                + attValue['edgy']*0.3045
                + attValue['fastpaced']*0.0559
                + attValue['disturbing']*0.1366
                + attValue['dramatic']*(-0.1253)
                + attValue['outrageous']*0.6510
                + attValue['exciting']*(-0.0527)
                + attValue['calming']*(-0.1322)
                + attValue['slow']*(-0.1126)
                + attValue['unoriginal']*(-0.0417)
                + attValue['uplifting']*0.0572
                + attValue['sexy']*0.0716
                + attValue['deep']*(-0.0807)
                + attValue['suspenseful']*(-0.2510)
                + attValue['thrilling']*(-0.2002)
                + attValue['scary']*(-0.03608)
    }
};

export function getDimValueNorm(dimValueRaw) {
    return {
        'gravity': (dimValueRaw['gravity'] - dimMinMax['gravity']['min'])/(dimMinMax['gravity']['max']-dimMinMax['gravity']['min']),
        'relatability': (dimValueRaw['relatability'] - dimMinMax['relatability']['min'])/(dimMinMax['relatability']['max']-dimMinMax['relatability']['min']),
        'heart': (dimValueRaw['heart'] - dimMinMax['heart']['min'])/(dimMinMax['heart']['max']-dimMinMax['heart']['min']),
        'originality': (dimValueRaw['originality'] - dimMinMax['originality']['min'])/(dimMinMax['originality']['max']-dimMinMax['originality']['min']),
        'adrenaline': (dimValueRaw['adrenaline'] - dimMinMax['adrenaline']['min'])/(dimMinMax['adrenaline']['max']-dimMinMax['adrenaline']['min']),
        'smarts': (dimValueRaw['smarts'] - dimMinMax['smarts']['min'])/(dimMinMax['smarts']['max']-dimMinMax['smarts']['min']),
        'passion': (dimValueRaw['passion'] - dimMinMax['passion']['min'])/(dimMinMax['passion']['max']-dimMinMax['passion']['min']),
        'levity': (dimValueRaw['levity'] - dimMinMax['levity']['min'])/(dimMinMax['levity']['max']-dimMinMax['levity']['min'])
    };
}